import { arrayToCamelCase } from '@cian/ui/app/services/utils';
import { getCategoryInfo } from '../../../../shared/utils';

// DEPRECATED. Нужно растащить на отдельные утилиты в shared/utils/category

// Сервис умеет:
// — По типу недвижимости и типу сделки получить категорию
export default [function () {
  let search = {};

  const getCategoryByInfo = (dealType, objectType, rentDuration) => {
    if (dealType && objectType) {
      const dailyPrefix = rentDuration === 'short' ? 'daily' : '';

      return arrayToCamelCase([dailyPrefix, objectType, dealType]);
    }

    return null;
  };

  const isCountry = category => ['houseSale', 'cottageSale', 'townhouseSale', 'houseShareSale', 'landSale',
    'houseRent', 'dailyHouseRent', 'cottageRent', 'townhouseRent', 'houseShareRent', 'commercialLandSale',
    'commercialLandRent'].indexOf(category) !== -1;

  const getSearch = () => search;

  const setSearch = ({ dealType, rentDuration, propertyType, objectType }) => search = {
    dealType,
    rentDuration,
    propertyType,
    objectType,
  };

  return {
    $get: () => ({
      getInfoByCategory: getCategoryInfo,
      getCategoryByInfo,
      isCountry,
      getSearch,
    }),

    setSearch,
  };
}];
